import { BaseContent } from '..';
import useTranslation from 'next-translate/useTranslation';
import { NotificationContentProps } from '../props';
import { BonusWithdrawalNotification } from '@/models/notification/notification';
import { BonusWithdrawalExtraParams } from '@/models/notification/notificationExtraParams';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export default function BonusWithdrawalContent({
  notification,
  type,
}: NotificationContentProps<BonusWithdrawalNotification>) {
  const { t } = useTranslation('notify');
  const extra: BonusWithdrawalExtraParams = notification.extra;

  return (
    <BaseContent
      icon="fa-solid fa-money-bill-transfer"
      title={t('withdraw_bonus_title')}
      description={t('withdraw_bonus_description', {
        amount: getMoneyOrAmount(extra.amount),
        app_provider: process.env.NEXT_PUBLIC_BET_NAME,
      })}
      type={type}
      createdAt={notification?.createdAt ?? ''}
      notificationTypeId={notification?.type?.id}
      //@ts-ignore
      extra={notification?.extra}
    />
  );
}
